import React, { useState, useEffect } from "react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { Layout, Menu, Modal, Input, message } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { LogoutUser } from "../../Redux/actions/authentication";
import { getCart } from "../../Redux/actions/cartActions";
import CartModal from "../cart/cartModal";
import PackageQRScanner from "../packages/PackageQRScanner";

import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  QrcodeOutlined,
  LogoutOutlined,
  ShopOutlined,
  BarsOutlined,
  CoffeeOutlined,
  InboxOutlined,
  AccountBookOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  AreaChartOutlined,
  ShoppingOutlined,
  AuditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  BarcodeOutlined,
} from "@ant-design/icons";

import "./styles.scss";
import "./styles.css";

const { Header, Content, Sider } = Layout;
const { confirm } = Modal;
const HQ_BRANCH_ID = "iVqgep3urhVOSZEd2KBH";
const HQ_BRANCH_NAME = "HQ";

const Index = ({ children }) => {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [menuKey, setMenuKey] = useState("packages"); // keep as string
  const [password, setPassword] = useState("");

  const { user } = useSelector(
    (state) => ({
      user: state.auth.user,
    }),
    shallowEqual
  );
  const canAccessAnalytics =
    user &&
    (user.role === "admin" ||
      (user.role === "warehouse" &&
        user.branch === HQ_BRANCH_ID &&
        (!user.branch_name || user.branch_name === HQ_BRANCH_NAME)));

  // Silence ONLY the Chromium ResizeObserver noise (keeps real errors visible)
  useEffect(() => {
    const handler = (e) => {
      const msg = e?.message || "";
      if (
        msg.includes("ResizeObserver loop limit exceeded") ||
        msg.includes(
          "ResizeObserver loop completed with undelivered notifications"
        )
      ) {
        // Ignore this specific browser bug
        e.preventDefault?.();
        return;
      }
    };
    // console.log(window.location.pathname.split("/")[1]);
    setMenuKey(window.location.pathname.split("/")[1]);
    window.addEventListener("error", handler);
    return () => window.removeEventListener("error", handler);
  }, []);

  useEffect(() => {
    // auth check & side effects only after user changes
    if (user) {
      if (user.role && user.role !== "none") {
        setAuthenticated(true);
        // Fetch cart only when authenticated
        dispatch(getCart());
      } else {
        setAuthenticated(false);
        window.location.href = "/";
      }
    } else if (
      window.location.pathname !== "/" &&
      window.location.pathname !== "/register"
    ) {
      setAuthenticated(false);
      window.location.href = "/";
    }
  }, [user, dispatch]);

  const changeRoute = (route) => {
    // if you’re on react-router v5 and want SPA nav, you can use useHistory().push(route)
    window.location.href = route;
  };

  const showConfirm = () => {
    confirm({
      title: "Input Password",
      icon: <ExclamationCircleOutlined />,
      content: (
        <Input.Password
          placeholder="input password"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
        />
      ),
      onOk() {
        if (password === "passbutan") {
          message.success("access granted");
          setMenuKey("analytics");
          changeRoute("/analytics");
        } else {
          message.error("wrong password");
        }
      },
    });
  };

  const logoutHandler = () => {
    dispatch(LogoutUser());
    window.location.href = "/";
  };

  return (
    <Layout className="mainDivLayout">
      {!collapsed && authenticated ? (
        <Sider trigger={null} collapsible collapsed={collapsed} reverseArrow>
          <div className="sider">
            <div>
              <div className="logo" />
              <Menu theme="dark" mode="inline" selectedKeys={[menuKey]}>
                <Menu.Item key="cart" icon={<ShoppingCartOutlined />}>
                  <CartModal navbutton />
                </Menu.Item>

                <Menu.Item key="scanqr" icon={<QrcodeOutlined />}>
                  <PackageQRScanner
                    showButton={false}
                    onCloseModal={() => window.location.reload()}
                  />
                </Menu.Item>

                <Menu.Item
                  key="packages"
                  icon={<InboxOutlined />}
                  onClick={() => {
                    setMenuKey("packages");
                    changeRoute("/");
                  }}
                >
                  Packages
                </Menu.Item>

                <Menu.Item
                  key="products"
                  icon={<CoffeeOutlined />}
                  onClick={() => {
                    setMenuKey("products");
                    changeRoute("/products");
                  }}
                >
                  Products
                </Menu.Item>

                <Menu.Item
                  key="dailysales"
                  icon={<ShoppingOutlined />}
                  onClick={() => {
                    setMenuKey("dailysales");
                    changeRoute("/dailysales");
                  }}
                >
                  Daily Sales
                </Menu.Item>

                <Menu.Item
                  key="sales"
                  icon={<BarcodeOutlined />}
                  onClick={() => {
                    setMenuKey("sales");
                    changeRoute("/sales");
                  }}
                >
                  Sales
                </Menu.Item>

                <Menu.Item
                  key="monthlyaudit"
                  icon={<AuditOutlined />}
                  onClick={() => {
                    setMenuKey("monthlyaudit");
                    changeRoute("/monthlyaudit");
                  }}
                >
                  Audit
                </Menu.Item>

                {user &&
                (user.role === "warehouse" || user.role === "manager") ? (
                  <Menu.Item
                    key="wasteditems"
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      setMenuKey("wasteditems");
                      changeRoute("/wasteditems");
                    }}
                  >
                    Wasted Items
                  </Menu.Item>
                ) : null}

                {user &&
                (user.role === "admin" ||
                  user.role === "warehouse" ||
                  user.role === "manager") ? (
                  <Menu.Item
                    key="purchasing"
                    icon={<WalletOutlined />}
                    onClick={() => {
                      setMenuKey("purchasing");
                      changeRoute("/purchasing");
                    }}
                  >
                    Purchasing
                  </Menu.Item>
                ) : null}

                {user && user.role === "admin" ? (
                  <Menu.Item
                    key="productcategories"
                    icon={<BarsOutlined />}
                    onClick={() => {
                      setMenuKey("productcategories");
                      changeRoute("/productcategories");
                    }}
                  >
                    Product Categories
                  </Menu.Item>
                ) : null}

                {user && user.role === "admin" ? (
                  <Menu.Item
                    key="brands"
                    icon={<BarsOutlined />}
                    onClick={() => {
                      setMenuKey("brands");
                      changeRoute("/brands");
                    }}
                  >
                    Brands
                  </Menu.Item>
                ) : null}

                {user && user.role === "admin" ? (
                  <Menu.Item
                    key="locations"
                    icon={<ShopOutlined />}
                    onClick={() => {
                      setMenuKey("locations");
                      changeRoute("/locations");
                    }}
                  >
                    Locations
                  </Menu.Item>
                ) : null}

                {user && user.role === "admin" ? (
                  <Menu.Item
                    key="users"
                    icon={<UserOutlined />}
                    onClick={() => {
                      setMenuKey("users");
                      changeRoute("/users");
                    }}
                  >
                    Users
                  </Menu.Item>
                ) : null}

                {user && user.role === "admin" ? (
                  <Menu.Item
                    key="exchangerate"
                    icon={<AccountBookOutlined />}
                    onClick={() => {
                      setMenuKey("exchangerate");
                      changeRoute("/exchangerate");
                    }}
                  >
                    Exchange rate
                  </Menu.Item>
                ) : null}

                {canAccessAnalytics ? (
                  <Menu.Item
                    key="analytics"
                    icon={<AreaChartOutlined />}
                    onClick={() => {
                      setMenuKey("analytics");
                      changeRoute("/analytics");
                    }}
                  >
                    Analytics
                  </Menu.Item>
                ) : null}
              </Menu>
            </div>

            <div>
              <Menu theme="dark" mode="inline" selectedKeys={[]}>
                <Menu.Item
                  key="logout"
                  onClick={logoutHandler}
                  icon={<LogoutOutlined />}
                >
                  Logout
                </Menu.Item>
              </Menu>
              <div className="branch">{user ? user.branch_name : ""}</div>
            </div>
          </div>
        </Sider>
      ) : null}

      <Layout className="site-layout">
        {authenticated ? (
          <div
            onClick={() => {
              setCollapsed(!collapsed);
            }}
            className="iconcollapse"
          >
            {collapsed ? (
              <MenuUnfoldOutlined className="iconColor" />
            ) : (
              <MenuFoldOutlined className="iconColor" />
            )}
          </div>
        ) : null}

        <CartModal />

        <Content
          className="site-layout-background content"
          style={
            user
              ? {
                  margin: "24px 16px",
                  minHeight: 280,
                  overflow: "auto", // helps avoid resize thrash in some layouts
                }
              : undefined
          }
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Index;
